import RtmClientManager from './RtmClientManager'
import aes from '../utils/aes'
import {getVal, hideDialog, isnull, localGet, stringToUint8Array, Toast, Uint8ArrayToString} from '../utils/tools'
import {log, loge} from '../utils/devext'
import global from '../config/global'
import Tips from '../utils/Tips'
import MessageBean from '../ent/MessageBean'

export const CustomMessageType = {
  SysRoomHint: 1, // 房间提示

  SysJoinLoom: 2, // 加入房间

  SysTextMessage: 3, // 弹幕消息

  SysSendGift: 4, // 礼物消息
  SysIsMute: 5, // 禁言
  SysCanleMute: 6, // 取消禁言

  SysRoomMessage: 7, // 房间信息 做房间页面刷新

  SysTAKEANCHOR: 8, // 带走主播

  /**
   * pk匹配成功
   *
   * content = VideoChatRoomPkMatchSuccessedMsgBean   json
   */
  SysPkMatchSuccess: 9,
  /**
   * pk结束
   */
  SysPkEnd: 10,
  /**
   * pk分数更新
   *
   * content = VideoChatRoomPkPointUpdatedMsgBean     json
   */
  SysPkPointUpdate: 11,
  /**
   * pk倒计时结束
   */
  SysPkTimeUp: 12,
  /**
   * pk准备好下一局
   *
   * content = 准备方的accountId
   */
  SysPkOnceMore: 13,
  /**
   * pk中对方逃跑
   */
  SysPkRunAway: 14,
  /**
   * pk私聊开关改变
   * content = {"roomId":1,"privateChatFlag":1}
   * 1:开启
   * 2:关闭
   */
  SysPkPrivateFlagChange: 15,
  /**
   * 直播间更新房间观众列表
   */
  SysUpdateRoomMember: 16,
  /**
   * 点对点消息，pk中通知对方房主自己这边已经关闭视频
   * content = "0" / "1"
   */
  SysPeerMsgVideoMuteChange: 17,

  /**
   * 转盘消息
   * @return
   */
  SYSTURNTABLE: 18,
  /**
   * 禁言列表变化
   */
  MUTE_LIST_CHANGE: 19

}

export const ChannelAttrKey = {
  ATTR_KEY_MUTE_PK_AUDIO: 'muteOpAudio',
  ATTR_VALUE_MUTE: 'true',
  ATTR_VALUE_UNMUTE: 'false',
  ATTR_KEY_MUTE_PK_VIDEO: 'muteOpVideo'
}

export default class RtmManager {
  rtmClient = null
  channelJob = ''
  static isLogined = false
  isJoinedChannel = false
  curChannel = ''
  rtmChannel = null
  retryCount = 0
  retryJob = null
  hasBeenMuted = false
  rtmListener = null

  page = null

  static inLogin = false

  constructor (rtmListener) {
    this._rtmListener = rtmListener
  }

  setContext (vuePage) {
    this.page = vuePage
  }

  checkClient (useDefault = true, inLogin = false) {
    if (this.rtmClient == null) {
      this.rtmClient = RtmClientManager.getClient(useDefault)
    }
    if (this.rtmClient != null && !inLogin && !this.rtmClient._logined) {
      this.isLogined = false
      this.login()
      return false
    } else {
      return true
    }
  }

  login () {
    if (this.rtmClient == null) {
      this.rtmClient = RtmClientManager.getClient()
    }
    if (this.isLogined || this.inLogin) {
      return
    }
    this.inLogin = true
    this.rtmClient.init(aes.decrypt(global.agoapp))
    this.rtmClient.login(global.getUserDisplay()).then(() => {
      console.log('login')
      this.isLogined = true
      this.inLogin = false
      this.rtmClient._logined = true
      log('RTMLOGIN', 'Login: ' + global.user.accountId, ' token: ', '')
      this.tryJoinChannel()
    }).catch((err) => {
      console.log(err)
      this.inLogin = false
    })

  }

  /**
   * 外部调用
   */
  startJoinChannel (channel, rtmListener) {
    this.curChannel = channel
    this.rtmListener = rtmListener
    if (this.checkClient(true)) {
      this.tryJoinChannel()
    }
  }

  tryJoinChannel () {
    // 判断条件：1.当前没有加入频道job   2.已登陆   3.未加入频道    4.频道号不为null
    let parent = this
    if ((isnull(this.channelJob)) && this.isLogined && !this.isJoinedChannel && !isnull(this.curChannel)) {
      log('tryJoinChannel', '创建加入频道任务')
      this.channelJob = setTimeout(this.doJoinChannel(), 1000, this)
    }
  }

  doJoinChannel () {
    this.checkClient()
    log('doJoinChannel', 'doJoinChannel   currChannel=' + this.curChannel)
    this.rtmChannel = this.rtmClient.client.createChannel(this.curChannel)

    if (this.rtmChannel == null) {
      this.retryJoinChannel()
      return
    }
    this.rtmChannel.join().then(() => {
      this.rtmListener.onJoinChannel(true)
      this.bindChannelEvents()
      this.getRtmChannelInfo()
    }).catch(e => {
      loge('doJoinChannel', 'Rtm join channel onFailure!!!   info' + e)
      this.retryJoinChannel()
    })
  }

  retryJoinChannel () {
    if (this.retryCount < 3) {
      this.retryCount++
      log('retryJoinChannel', '加入频道    重试第 ' + this.retryCount + ' 次')
      this.retryJob = setTimeout(this.tryJoinChannel(), 200)
    } else {
      this.rtmListener.onJoinChannel(false)
      loge('doJoinChannel', 'Failed to join the channel')
    }
  }

  cancelRetry() {
    if (!isnull(this.retryJob)) {
      clearTimeout(this.retryJob)
      this.retryJob = null
      this.retryCount = 0
    }
  }

  cancelChannelJob() {
    if (!isnull(this.channelJob)) {
      clearTimeout(this.channelJob)
      this.channelJob = null
    }
  }

  leaveChannel() {
    this.cancelChannelJob()
    this.cancelRetry()
    this.isJoinedChannel = false
    this.curChannel = null
    this.hasBeenMuted = false

    if (this.rtmChannel != null) {
      this.rtmChannel.leave(null).then(() => {
        log('leaveChannel', 'success');
      }).catch(e => {
        log('leaveChannel', 'failed[' + e + ']');
      });
      this.rtmChannel = null
    }
  }

  logout () {
    this.isLogined = false
    this.inLogin = false
    if (this.rtmClient != null) {
      this.rtmClient._logined = false
      this.rtmClient.logout(null)
    }
  }

  release () {
    this.leaveChannel()
    this.logout()
    // RtmClientManager.unregisterListener(rtmClientListener)

    this.rtmClient = null
  }

  getRtmChannelInfo (channel, pageV) {
    this.checkClient()
    let target = this
    this.rtmClient.client.getChannelAttributes(this.curChannel).then((channelAttributes) => {
      for (let attributesKey in channelAttributes) {
        let attr = channelAttributes[attributesKey]

        if (attributesKey === global.getUserId().toString()) {
          target.hasBeenMuted = target.isMute(attr.value)
        } else if (attributesKey === ChannelAttrKey.ATTR_KEY_MUTE_PK_AUDIO) {
          // 静音pk
          log('getChannelAttrs', '获取pk中静音对方的值     value=' + attr.value)
          target.rtmListener.onPkRemoteAudioMuteChange(attr.value === ChannelAttrKey.ATTR_VALUE_MUTE)
        } else if (attributesKey === ChannelAttrKey.ATTR_KEY_MUTE_PK_VIDEO) {
          // pk视频关闭
          target.rtmListener.onPkRemoteVideoMuteChange(getVal(attr, 'value', false) === ChannelAttrKey.ATTR_VALUE_MUTE)
        }
      }
    })
  }

  /**
   * 判断是否被禁言文字消息
   */
  isMute(value) {
    if (isnull(value)) {
      return false
    }

    if (value === '1') {
      return true
    } else {
      var channelAttribute = JSON.parse(isnull(value.value)?value:value.value)
      var now = new Date()
      log('时间封禁', '' + channelAttribute.muteExpire)
      log('时间当前', '' + now)
      if (channelAttribute.muteExpire > now.getTime()) {
        return true
      }
    }
    return false
  }

  bindChannelEvents() {
    let target = this
    this.rtmChannel.on('ChannelMessage', (message, memberId) => {
      log('ChannelMessage', [message, memberId].join(' '))
      if (isnull(message) || isnull(memberId)) {
        return
      }
      try {
        var messageBean = new MessageBean(memberId, message, false);
        if (message.messageType === 'RAW') {
          var jsonElement = JSON.parse(Uint8ArrayToString(message.rawMessage));
          messageBean._customMessage = jsonElement
          log("ChannelMessage", "onMessageReceived ---" + jsonElement)
          target.rtmListener.onReceiveMessage(jsonElement)
        }
      } catch (e) {
        loge("ChannelMessage", e.toString())
      }

    })
    this.rtmChannel.on('MemberLeft', (memberId) => {

    })
    this.rtmChannel.on('MemberJoined', (memberId) => {

    })
    this.rtmChannel.on('AttributesUpdated', (attributes) => {
      var isFindMeMute = false
      for (let attributesKey in attributes) {
        let attr = attributes[attributesKey]
        if (attributesKey == global.user.accountId) {
          var currentMultMessage = target.isMute(attributes[attributesKey])
          if (currentMultMessage != target.hasBeenMuted) {
            target.hasBeenMuted = currentMultMessage
            if (currentMultMessage) {
              target.rtmListener.onMuteChange(true)
              Toast.info(Tips.e_video_mute, target.page)
            } else {
              target.rtmListener.onMuteChange(false)
              Toast.info(Tips.e_video_unmute, target.page)
            }
          }
          isFindMeMute = true
        } else if (attributesKey == ChannelAttrKey.ATTR_KEY_MUTE_PK_AUDIO) {// 静音pk
          log("AttributesUpdated", "获取pk中静音对方的值     value=" + attr)
          target.rtmListener.onPkRemoteAudioMuteChange(getVal(attr, 'value', false) == ChannelAttrKey.ATTR_VALUE_MUTE)
        } else if (attributesKey == ChannelAttrKey.ATTR_KEY_MUTE_PK_VIDEO) { // PK视频关闭
          target.rtmListener.onPkRemoteVideoMuteChange(getVal(attr, 'value', false) === ChannelAttrKey.ATTR_VALUE_MUTE)
        }
      }
      // 如果没找到自己的禁言信息，并且之前是被禁言的
      // 证明自己被房主取消禁言了
      if (!isFindMeMute && this.hasBeenMuted) {
        target.hasBeenMuted = false
        target.rtmListener.onMuteChange(false)
        Toast.info(Tips.e_video_unmute, target.page)
      }
    })
    this.rtmChannel.on('MemberCountUpdated', (memberCount) => {

    })
  }

  //region ***************** 禁言 *****************

  //rtmAttrs: List<RtmChannelAttribute>? = null
  rtmAttrs = new Array;

  // 但前房间禁言列表
  //  currMuteMembers = HashSet<Int>()
  currMuteMembers = null;
  rtmAttrs = null;

  /**
   * list<id>
   * @param list
   */
  updateMuteMember(list) {
    log("updateMuteMember", "updateMuteMember--" + list)
    this.currMuteMembers = new Array();
    if (!isnull(list)) {
      // for (let i = 0; i < list.length; i++) {
      //   let curId = list[i];
      //   if (this.currMuteMembers.indexOf(curId) != -1) {
      //     this.currMuteMembers.push(curId)
      //   }
      // }
      this.currMuteMembers.push(...list)
    } else {
      this.rtmAttrs = null
    }
  }

  isUserMuted(accountId) {
    return (this.currMuteMembers && this.currMuteMembers.indexOf(accountId) != -1) || (!isnull(this.rtmAttrs) && this.isMute((this.rtmAttrs.find(accountId.toString()))))
  }

  isSelfMuted() {
    return this.isUserMuted(global.user.accountId)
  }

  /**
   * 发送rtm消息
   * @param needSend  是否需要发送到远端
   * @param needRefreshLocal  是否需要回调到刷新本地消息
   */
  sendMessage(_type = 0, text = "", _giftId = 0, _combo = 1, _isBlindBox = false, userBean = null, needSend = true, needRefreshLocal = true) {
    if (!this.page.$root.online) {
      Toast.error('No network', this.page)
      hideDialog(this.page)
      return
    }
    log("sendMessage", "sendChannelMessage-- type=" + _type + "  text=" + text)
    let customMessage = {
      userId: !isnull(userBean) ? userBean.accountId : global.getUser().accountId,
      userName: !isnull(userBean) ? userBean.nickName : global.getUser().nickName,
      userType: !isnull(userBean) ? userBean.userType : global.getUser().userType,
      avatar: !isnull(userBean) ? userBean.avatar : global.getUser().avatar,
      type: _type,
      content: text,
      isVip: global.isVip(),
      isSvip: global.getUser().isSVip,
      isPrivilege: global.hasMultiRoomPrivilege() || global.getUser().isSVip,
      giftId: _giftId,
      isblindBox: _isBlindBox ? 1 : 0,
      combo: _combo,
      uniqueTagUrl: global.getUniTagUrl()
    };
    this.checkClient()
    var rawMessage = this.rtmClient.client.createMessage({
      messageType: 'RAW',
      rawMessage: stringToUint8Array(JSON.stringify(customMessage)),
      description: 'web'
    })
    if ([CustomMessageType.SysRoomHint, CustomMessageType.SysJoinLoom, CustomMessageType.SysTextMessage].indexOf(_type) != -1) {
      if ((this.isSelfMuted() || this.hasBeenMuted) && _type != CustomMessageType.SysRoomHint) {
        Toast.error(Tips.e_video_mute, this.page);
      } else {
        if (_type != CustomMessageType.SysRoomHint && needSend) {
          this.sendChannelMessage(rawMessage)
        }

        if (needRefreshLocal) {
          this.rtmListener.onReceiveMessage(customMessage)
        }
      }
    } else {
      if (needSend) {
        this.sendChannelMessage(rawMessage)
      }
      if (needRefreshLocal) {
        this.rtmListener.onReceiveMessage(customMessage)
      }
    }
  }

  /**
   * API CALL: send message to a channel
   */
  sendChannelMessage(message) {
    this.rtmChannel.sendMessage(message).then(() => {
      log('sendChannelMessage', "发送消息onSuccess ")
    }).catch(error => {
      loge('sendChannelMessage', error)
      loge('sendChannelMessage', "发送消息onFailure: " + error)
    })

  }

}



// WEBPACK FOOTER //
// ./src/rtm/RtmManager.js